export default __webpack_public_path__ + "static/31-25fe3e43ecf5268e3dbfb3535744bccf.png";